import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic, clientPublicService } from 'helper/axios'
let resError = ''
export const getDataHoliday = async ({ token, id, parent_id, level_id }) => {
  try {
    return await clientPublic

      //asc desc
      .get(
        `holiday/main?com_id=${parent_id}&oper_id=${level_id}&sub_id=${id}&limit=999`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getDataHolidayDetail = async ({ token, holiday_id }) => {
  try {
    return await clientPublic

      .get(`holiday/data/search?holiday_id=${holiday_id}&limit=999999`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getCheckUsed = async ({ token, holiday_id }) => {
  try {
    return await clientPublic

      .get(`holiday/used/${holiday_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getTreeHoliday = async ({ token, language }) => {
  try {
    return await clientPublic
      .get(`holiday/tree?lang=${language}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const saveHoliday = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`holiday`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const saveHolidayDetail = async ({ params, token }) => {
  let aaaaa = ''
  try {
    return await clientPublic
      .post(`holiday/data`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        aaaaa = response
        const Error = get(response, 'data', '')
        return response
      })
  } catch (error) {
    console.error('error', error)
    return aaaaa
  }
}

export const deleteCompany = async ({ params, token, idHoliday }) => {
  try {
    return await clientPublic
      .delete(`holiday/${idHoliday}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },

        data: params,
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const deleteHolidayDetail = async ({
  params,
  token,
  idHoliday,
  idHolidayDetail,
}) => {
  try {
    return await clientPublic
      .delete(`holiday/data?id=${idHolidayDetail}&holiday_id=${idHoliday}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },

        data: params,
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const updateHoliday = async ({ params, token, idCompany }) => {
  try {
    return await clientPublic
      .put(`holiday/${idCompany}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return resError
  }
}

export const updateHolidayDetail = async ({ params, token, idHolidayDetail }) => {
  try {
    return await clientPublic
      .put(`holiday/data/${idHolidayDetail}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const uploadHoliday = async ({ params, token }) => {
  try {
    return await clientPublic
      .post('holiday/data/upload', params, {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const checkHoliday = async ({ params, token }) => {
  try {
    return await clientPublic
      .post('holiday/data/checkupload', params, {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const exportHolidayDetail = async ({ params, token, holiday_id }) => {
  try {
    return await clientPublic
      .post(`holiday/data/export?holiday_id=${holiday_id}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const exportHolidayV2 = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`holiday/data/export`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const holidayDataName = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`holiday/name/search`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

// new api service-project
export const getCompanyData = async ({ token }) => {
  try {
    return await clientPublicService
      .get(`/core/management/company/dropdown`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getTreeHolidayV2 = async ({ token, language }) => {
  try {
    return await clientPublicService
      .post(
        `/core/management/holiday/tree`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
